import { NetworkError } from '../../state-machine/actions/genericActions';

const getIpAddress = async (): Promise<string> => {
  try {
    return await clientIpService.fetchClientIp();
  } catch (err: any) {
    // eslint-disable-next-line no-throw-literal
    throw { errorGeneral: err } as NetworkError;
  }
};

// TODO: modernize this
const clientIpService = {
  async fetchClientIp() {
    let retryAttempts = 3;
    let ipAddress = '';
    while (retryAttempts > 0) {
      try {
        const { ip } = await (await fetch('https://jsonip.com')).json();
        ipAddress = ip;
        retryAttempts = 0;
      } catch (e) {
        console.error(`could not obtain client ip address: ${e}`);
        retryAttempts--;
      }
    }
    return ipAddress;
  },
};

export default getIpAddress;
